import { useDataChange, useDataValue } from 'Simple/Data'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let ids = useDataValue({
    context: 'selected',
    path: 'charge_ids',
    viewPath: props.viewPath,
  })
  let setChargeIds = useDataChange({
    context: 'selected',
    path: 'charge_ids',
    viewPath: props.viewPath,
  })
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    let mutationResponse = await executeMutation({
      ids,
    })
    if (mutationResponse.error) {
      notify(notifyError(`An error has occurred while deleting charges.`))
      return
    }

    notify(notifySuccess(`Charges deleted successfully.`))
    setChargeIds([])

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
